export { CanvasAbout as About } from 'themes/canvas/pages/CanvasAbout/CanvasAbout';
export { ZenHome as Home } from './ZenHome';
export { CanvasServices as Services } from 'themes/canvas/pages/CanvasServices/CanvasServices';
export { CanvasPortfolio as Portfolio } from 'themes/canvas/pages/CanvasPortfolio/CanvasPortfolio';
export { CanvasTeam as Team } from 'themes/canvas/pages/CanvasTeam/CanvasTeam';
export { CanvasContact as Contact } from 'themes/canvas/pages/CanvasContact/CanvasContact';
export { CanvasPackages as Packages } from 'themes/canvas/pages/CanvasPackages/CanvasPackages';
